export default "__VITE_PUBLIC_ASSET__2c5f39ed__"